module.exports = __webpack_public_path__ + "static/media/DESIGN.8ba165b4.mp4";